import { render, staticRenderFns } from "./KAMFormEdit.vue?vue&type=template&id=37fcae70&scoped=true"
import script from "./KAMFormEdit.vue?vue&type=script&lang=ts"
export * from "./KAMFormEdit.vue?vue&type=script&lang=ts"
import style0 from "./KAMFormEdit.vue?vue&type=style&index=0&id=37fcae70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcae70",
  null
  
)

export default component.exports